export default __webpack_public_path__ + "static/media/mui-face.47f48917.svg";